<template>
	<div class="list-container">
		<strong>{{ disabled_item }}</strong>
		<ul class="scrollable-list">
			<li
				v-for="(ordem, index) in ordens_servico"
				:key="index"
			>
				{{ ordem }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'ListaOrdensServico',
	props: {
		ordens_servico: {
			type: Array,
			required: true,
		},
		disabled_item: {
			type: String,
			required: true,
		},
	},
}
</script>

<style scoped>
.list-container {
	border: 1px solid #ccc;
	padding: 10px;
	margin-top: 10px;
	border-radius: 5px;
	background-color: #f9f9f9;
}

.scrollable-list {
	list-style-type: none;
	padding: 0;
	max-height: 100px;
	/* Altura máxima antes de ativar a rolagem */
	overflow-y: auto;
	/* Ativa a rolagem vertical */
}

ul {
	list-style-type: none;
	padding: 0;
}

li {
	padding: 8px;
	border-bottom: 1px solid #ccc;
}
</style>
